import { Link } from "react-router-dom";
import { useGetBlogQuery } from "../../../../Redux/Apis/blogApi";
import { fa_dateـetime } from "../../../../utils/PersianNum";

function Blog({name,caption,site_id}) {
    const {data , isLoading } = useGetBlogQuery(site_id)

    return ( 
        <div className="container-xxl py-5">
            <div className="container">
                <div className="section-title text-center">
                    <h1 className="display-5 mb-5">{name}</h1>
                </div>
                <div className="row g-4">
                    {
                    isLoading ? "در حال بارگذاری" :
                    data && data.map((row,index) => 
                    <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s" key={index}>
                        <div className="service-item">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src={row.image} alt={row.title}/>
                            </div>
                            <div className="p-4 border border-5 border-light border-top-0">
                                <h4 className="mb-3">{row.title}</h4>
                                <p className="blog-meta">
                                    <span className="author"><i className="fas fa-user"></i>مدیر</span>
                                    <span className="date"><i className="fas fa-calendar"></i>{fa_dateـetime(row.create_date)}</span>
                                </p>
                                <p className="excerpt">{row.excerpt}</p>
                                <Link className="fw-medium" to={`/post/${row.id}`}>مشاهده کامل<i className="fa fa-arrow-left ms-2"></i></Link>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Blog;